"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jQuery = _interopRequireDefault(require("jQuery"));

var _Cookies = _interopRequireDefault(require("Cookies"));

var _q = _interopRequireDefault(require("q"));

var _Url = _interopRequireDefault(require("urlinator/Url"));

var REMEMBER_DEFAULT = _Cookies.default.get('prefs') === '1';
var _default = {
  login: function login(credentials, lb) {
    credentials.rememberLogin = credentials.rememberLogin !== undefined ? credentials.rememberLogin : REMEMBER_DEFAULT;
    return _q.default.Promise.resolve(_jQuery.default.ajax({
      method: 'POST',
      url: new _Url.default('/login-api/v1/login', {
        lb: lb
      }).href,
      contentType: 'application/json',
      xhrFields: {
        withCredentials: true
      },
      data: JSON.stringify(credentials)
    }));
  },
  prep: function prep(lb) {
    return _q.default.Promise.resolve(_jQuery.default.ajax({
      method: 'POST',
      url: new _Url.default('/login-api/v1/login/prep', {
        lb: lb
      }).href,
      contentType: 'application/json',
      xhrFields: {
        withCredentials: true
      }
    }));
  },
  verify: function verify(_ref) {
    var firstAttempt = _ref.firstAttempt,
        email = _ref.email;
    var params = {
      fallback: !firstAttempt
    };

    if (email) {
      params.email = email;
    } else {
      params.hubspotutk = _Cookies.default.get('hubspotutk');
    }

    return _q.default.Promise.resolve(_jQuery.default.ajax({
      method: 'POST',
      url: new _Url.default('/login-api/v1/cookie-verify', {
        lb: 'api',
        params: params
      }).href,
      xhrFields: {
        withCredentials: true
      }
    }));
  }
};
exports.default = _default;
module.exports = exports.default;